// Vendors
import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';

// Src
import { authPersistConfig } from './persistConfig';

// CLIENT STATE
import authenticationReducer from '@/domain/authentication/reducers/authenticationReducer';
import snackBarReducer from '@/infrastructure/redux/clientState/snackBarReducer';
import versionReducer from '@/infrastructure/redux/clientState/versionReducer';

// Types
type AuthenticationPersistReducerType = ReturnType<typeof authenticationReducer>;

// RootReducer
const rootReducer = combineReducers({
    authenticationReducer: persistReducer<AuthenticationPersistReducerType>(authPersistConfig, authenticationReducer),
    snackBarReducer: snackBarReducer,
    versionReducer: versionReducer,
});

export default rootReducer;
